import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  details: { input: any; output: any; }
};

export type AdminAppResponse = {
  __typename?: 'AdminAppResponse';
  data?: Maybe<AppAdminData>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type AppAdminData = {
  __typename?: 'AppAdminData';
  appAdminName?: Maybe<Scalars['String']['output']>;
  apps?: Maybe<Array<Maybe<AppData>>>;
};

export type AppData = {
  __typename?: 'AppData';
  appName?: Maybe<Scalars['String']['output']>;
  appSSOid?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['String']['output']>;
};

export type ApplicationData = {
  __typename?: 'ApplicationData';
  app_name?: Maybe<Scalars['String']['output']>;
  attribute_is_required?: Maybe<Scalars['Boolean']['output']>;
  attribute_key?: Maybe<Scalars['String']['output']>;
  attribute_order?: Maybe<Scalars['Int']['output']>;
  attribute_type?: Maybe<Scalars['String']['output']>;
  attribute_value?: Maybe<Scalars['String']['output']>;
};

export type ApplicationDataInput = {
  app_name?: InputMaybe<Scalars['String']['input']>;
  attribute_is_required?: InputMaybe<Scalars['Boolean']['input']>;
  attribute_key?: InputMaybe<Scalars['String']['input']>;
  attribute_order?: InputMaybe<Scalars['Int']['input']>;
  attribute_type?: InputMaybe<Scalars['String']['input']>;
  attribute_value?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationDataResponse = {
  __typename?: 'ApplicationDataResponse';
  data?: Maybe<Array<Maybe<ApplicationData>>>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Boolean']['output']>;
};

export type ChangePasswordResponse = {
  __typename?: 'ChangePasswordResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ChangeUserAttributeInput = {
  attribute: Scalars['String']['input'];
  id: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ContactType = {
  __typename?: 'ContactType';
  AccountId?: Maybe<Scalars['String']['output']>;
  Account_Name__c?: Maybe<Scalars['String']['output']>;
  Additional_Email__c?: Maybe<Scalars['String']['output']>;
  Contact_DPL_Whitelist__c?: Maybe<Scalars['String']['output']>;
  Contact_Denied_Persons_List__c?: Maybe<Scalars['String']['output']>;
  DPL_Blacklist__c?: Maybe<Scalars['String']['output']>;
  Double_Opt_In_Date_Time__c?: Maybe<Scalars['String']['output']>;
  Email_Opt_In__c?: Maybe<Scalars['String']['output']>;
  FirstName?: Maybe<Scalars['String']['output']>;
  Geo__c?: Maybe<Scalars['String']['output']>;
  Id: Scalars['String']['output'];
  Job_Function__c?: Maybe<Scalars['String']['output']>;
  Job_Level__c?: Maybe<Scalars['String']['output']>;
  LastName?: Maybe<Scalars['String']['output']>;
  LeadSource?: Maybe<Scalars['String']['output']>;
  MailingCity?: Maybe<Scalars['String']['output']>;
  MailingPostalCode?: Maybe<Scalars['String']['output']>;
  MailingState?: Maybe<Scalars['String']['output']>;
  PRM_Partner_Inactive__c?: Maybe<Scalars['String']['output']>;
  Partner_Oxygen_Access__c?: Maybe<Scalars['String']['output']>;
  Personal_Email__c?: Maybe<Scalars['String']['output']>;
  Preferred_Account_Name__c?: Maybe<Scalars['String']['output']>;
  Region__c?: Maybe<Scalars['String']['output']>;
  Role__c?: Maybe<Scalars['String']['output']>;
  Support_Portal_Admin__c?: Maybe<Scalars['String']['output']>;
  Title?: Maybe<Scalars['String']['output']>;
};

export type DplScreen = {
  __typename?: 'DplScreen';
  company: Scalars['String']['output'];
  country: Scalars['String']['output'];
  created: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type IssueActivationEmailType = {
  __typename?: 'IssueActivationEmailType';
  activationEmailSent?: Maybe<Scalars['Boolean']['output']>;
};

export type IssueActivationLinkType = {
  __typename?: 'IssueActivationLinkType';
  activationUrl?: Maybe<Scalars['String']['output']>;
};

export type IssueEmailFactorChallengeType = {
  __typename?: 'IssueEmailFactorChallengeType';
  emailFactorChallengeEmailSent?: Maybe<Scalars['Boolean']['output']>;
};

export type IssuePasswordResetEmailType = {
  __typename?: 'IssuePasswordResetEmailType';
  emailSent?: Maybe<Scalars['Boolean']['output']>;
  userType?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addAppAttribute?: Maybe<ApplicationDataResponse>;
  changeUserAttribute?: Maybe<OktaUserType>;
  changeUserPassword: ChangePasswordResponse;
  changeUserStatus?: Maybe<OktaUserType>;
  deleteUser?: Maybe<Scalars['Boolean']['output']>;
  downloadPiiReport?: Maybe<Scalars['Boolean']['output']>;
  issueAccountActivationEmail?: Maybe<IssueActivationEmailType>;
  issueAccountActivationLink?: Maybe<IssueActivationLinkType>;
  issueEmailFactorChallenge?: Maybe<IssueEmailFactorChallengeType>;
  issuePasswordResetEmail?: Maybe<IssuePasswordResetEmailType>;
  issueTemporaryPassword?: Maybe<ResponseTemporaryPasswordType>;
  removeUserDplTable?: Maybe<ResponseDplDeleteType>;
  updateOktaProfile?: Maybe<OktaUserType>;
};


export type MutationAddAppAttributeArgs = {
  data?: InputMaybe<Array<InputMaybe<ApplicationDataInput>>>;
};


export type MutationChangeUserAttributeArgs = {
  attribute?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};


export type MutationChangeUserPasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationChangeUserStatusArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  newStatus?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteUserArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  ticketNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDownloadPiiReportArgs = {
  username: Scalars['String']['input'];
};


export type MutationIssueAccountActivationEmailArgs = {
  username: Scalars['String']['input'];
};


export type MutationIssueAccountActivationLinkArgs = {
  username: Scalars['String']['input'];
};


export type MutationIssueEmailFactorChallengeArgs = {
  username: Scalars['String']['input'];
};


export type MutationIssuePasswordResetEmailArgs = {
  username: Scalars['String']['input'];
};


export type MutationIssueTemporaryPasswordArgs = {
  username: Scalars['String']['input'];
};


export type MutationRemoveUserDplTableArgs = {
  username: Scalars['String']['input'];
};


export type MutationUpdateOktaProfileArgs = {
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  nickName?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type OktaUserType = {
  __typename?: 'OktaUserType';
  activated?: Maybe<Scalars['String']['output']>;
  api_created?: Maybe<Scalars['String']['output']>;
  ciscoEmail?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  dpl_match?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  email_double_opt_in?: Maybe<Scalars['String']['output']>;
  email_double_opt_in_date?: Maybe<Scalars['String']['output']>;
  email_opt_in?: Maybe<Scalars['String']['output']>;
  email_validation_status?: Maybe<Scalars['String']['output']>;
  employeeNumber?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  geo_country?: Maybe<Scalars['String']['output']>;
  geo_country_code?: Maybe<Scalars['String']['output']>;
  geo_region?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  ip_address?: Maybe<Scalars['String']['output']>;
  is_blacklisted?: Maybe<Scalars['String']['output']>;
  is_denied_person?: Maybe<Scalars['String']['output']>;
  is_onetime_email_bypass_on?: Maybe<Scalars['String']['output']>;
  is_partner_inactive?: Maybe<Scalars['String']['output']>;
  is_support_portal_admin?: Maybe<Scalars['String']['output']>;
  is_whitelisted?: Maybe<Scalars['String']['output']>;
  job_function?: Maybe<Scalars['String']['output']>;
  job_level?: Maybe<Scalars['String']['output']>;
  lastLogin?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  leadSource?: Maybe<Scalars['String']['output']>;
  login?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  manager?: Maybe<Scalars['String']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  nickName?: Maybe<Scalars['String']['output']>;
  partner_oxygen_access?: Maybe<Scalars['Boolean']['output']>;
  passwordChanged?: Maybe<Scalars['String']['output']>;
  personal_email?: Maybe<Scalars['String']['output']>;
  primaryPhone?: Maybe<Scalars['String']['output']>;
  salesforce_account_id?: Maybe<Scalars['String']['output']>;
  salesforce_account_name?: Maybe<Scalars['String']['output']>;
  salesforce_account_record_type?: Maybe<Scalars['String']['output']>;
  salesforce_id?: Maybe<Scalars['String']['output']>;
  salesforce_lead_source?: Maybe<Scalars['String']['output']>;
  secondEmail?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusChanged?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  termsAccepted?: Maybe<Scalars['String']['output']>;
  termsAcceptedTime?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  userType?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type OktaUserTypeInput = {
  activated: Scalars['String']['input'];
  api_created?: InputMaybe<Scalars['String']['input']>;
  ciscoEmail?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  created: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  dpl_match?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  email_double_opt_in?: InputMaybe<Scalars['String']['input']>;
  email_double_opt_in_date?: InputMaybe<Scalars['String']['input']>;
  email_opt_in?: InputMaybe<Scalars['String']['input']>;
  email_validation_status?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  geo_country?: InputMaybe<Scalars['String']['input']>;
  geo_country_code?: InputMaybe<Scalars['String']['input']>;
  geo_region?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  is_blacklisted?: InputMaybe<Scalars['String']['input']>;
  is_denied_person?: InputMaybe<Scalars['String']['input']>;
  is_onetime_email_bypass_on?: InputMaybe<Scalars['String']['input']>;
  is_partner_inactive?: InputMaybe<Scalars['String']['input']>;
  is_support_portal_admin?: InputMaybe<Scalars['String']['input']>;
  is_whitelisted?: InputMaybe<Scalars['String']['input']>;
  job_function?: InputMaybe<Scalars['String']['input']>;
  job_level?: InputMaybe<Scalars['String']['input']>;
  lastLogin?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastUpdated: Scalars['String']['input'];
  leadSource?: InputMaybe<Scalars['String']['input']>;
  login: Scalars['String']['input'];
  mobilePhone?: InputMaybe<Scalars['String']['input']>;
  nickName?: InputMaybe<Scalars['String']['input']>;
  partner_oxygen_access?: InputMaybe<Scalars['Boolean']['input']>;
  passwordChanged: Scalars['String']['input'];
  primaryPhone?: InputMaybe<Scalars['String']['input']>;
  salesforce_account_id?: InputMaybe<Scalars['String']['input']>;
  salesforce_account_name?: InputMaybe<Scalars['String']['input']>;
  salesforce_account_record_type?: InputMaybe<Scalars['String']['input']>;
  salesforce_id?: InputMaybe<Scalars['String']['input']>;
  salesforce_lead_source?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  statusChanged: Scalars['String']['input'];
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  termsAccepted?: InputMaybe<Scalars['String']['input']>;
  termsAcceptedTime?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  checkDplTableUser?: Maybe<ResponseDplCheckType>;
  dplScreen?: Maybe<DplScreen>;
  getAdminApps?: Maybe<AdminAppResponse>;
  getAppAttribute?: Maybe<ApplicationDataResponse>;
  getSystemLogs?: Maybe<Array<Maybe<ResponseSystemLogsType>>>;
  oktaUserProfile?: Maybe<OktaUserType>;
  search?: Maybe<Array<Maybe<OktaUserType>>>;
  sfdcContactProfile?: Maybe<Array<Maybe<ContactType>>>;
};


export type QueryCheckDplTableUserArgs = {
  username: Scalars['String']['input'];
};


export type QueryDplScreenArgs = {
  email: Scalars['String']['input'];
};


export type QueryGetAppAttributeArgs = {
  appName: Scalars['String']['input'];
};


export type QueryGetSystemLogsArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOktaUserProfileArgs = {
  username?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchArgs = {
  search: Scalars['String']['input'];
};


export type QuerySfdcContactProfileArgs = {
  contact_id?: InputMaybe<Scalars['String']['input']>;
};

export type ResponseDplCheckType = {
  __typename?: 'ResponseDPLCheckType';
  dpl_match: Scalars['Boolean']['output'];
  email: Scalars['String']['output'];
};

export type ResponseDplDeleteType = {
  __typename?: 'ResponseDPLDeleteType';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ResponseSystemLogsType = {
  __typename?: 'ResponseSystemLogsType';
  actor?: Maybe<Scalars['String']['output']>;
  eventInfo?: Maybe<SystemLogsEventInfo>;
  target?: Maybe<Array<Maybe<SystemLogsTarget>>>;
  time?: Maybe<Scalars['String']['output']>;
};

export type ResponseTemporaryPasswordType = {
  __typename?: 'ResponseTemporaryPasswordType';
  tempPassword?: Maybe<Scalars['String']['output']>;
};

export type SystemLogsEventInfo = {
  __typename?: 'SystemLogsEventInfo';
  message?: Maybe<Scalars['String']['output']>;
  outcome?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type SystemLogsTarget = {
  __typename?: 'SystemLogsTarget';
  alternateId?: Maybe<Scalars['String']['output']>;
  detailEntry?: Maybe<Scalars['details']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type OktaUserQueryVariables = Exact<{
  username?: InputMaybe<Scalars['String']['input']>;
}>;


export type OktaUserQuery = { __typename?: 'Query', oktaUserProfile?: { __typename?: 'OktaUserType', login?: string | null, email: string, salesforce_id?: string | null, id?: string | null, dpl_match?: string | null, email_double_opt_in?: string | null, activated?: string | null, created?: string | null, email_validation_status?: string | null, is_blacklisted?: string | null, is_denied_person?: string | null, is_onetime_email_bypass_on?: string | null, is_partner_inactive?: string | null, is_support_portal_admin?: string | null, is_whitelisted?: string | null, nickName?: string | null, partner_oxygen_access?: boolean | null, salesforce_account_id?: string | null, salesforce_account_name?: string | null, salesforce_lead_source?: string | null, status?: string | null, streetAddress?: string | null, firstName?: string | null, lastName?: string | null, passwordChanged?: string | null, mobilePhone?: string | null, primaryPhone?: string | null, company?: string | null, country?: string | null, state?: string | null, city?: string | null, geo_country?: string | null, geo_country_code?: string | null, geo_region?: string | null, zipCode?: string | null, leadSource?: string | null, lastUpdated?: string | null, termsAccepted?: string | null, termsAcceptedTime?: string | null, lastLogin?: string | null, statusChanged?: string | null, email_double_opt_in_date?: string | null, job_function?: string | null, job_level?: string | null, title?: string | null, email_opt_in?: string | null, secondEmail?: string | null, personal_email?: string | null, ip_address?: string | null, latitude?: string | null, longitude?: string | null, manager?: string | null, employeeNumber?: string | null, countryCode?: string | null, ciscoEmail?: string | null, salesforce_account_record_type?: string | null } | null };

export type CheckDplTableQueryVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type CheckDplTableQuery = { __typename?: 'Query', checkDplTableUser?: { __typename?: 'ResponseDPLCheckType', dpl_match: boolean } | null };

export type GetSystemLogsQueryVariables = Exact<{
  email: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
}>;


export type GetSystemLogsQuery = { __typename?: 'Query', getSystemLogs?: Array<{ __typename?: 'ResponseSystemLogsType', actor?: string | null, time?: string | null, eventInfo?: { __typename?: 'SystemLogsEventInfo', message?: string | null, outcome?: string | null, type?: string | null } | null, target?: Array<{ __typename?: 'SystemLogsTarget', alternateId?: string | null, detailEntry?: any | null, displayName?: string | null, type?: string | null } | null> | null } | null> | null };

export type DplScreenQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type DplScreenQuery = { __typename?: 'Query', dplScreen?: { __typename?: 'DplScreen', firstName: string, lastName: string, email: string, company: string, country: string, created: string } | null };

export type IssuePasswordResetEmailMutationVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type IssuePasswordResetEmailMutation = { __typename?: 'Mutation', issuePasswordResetEmail?: { __typename?: 'IssuePasswordResetEmailType', emailSent?: boolean | null, userType?: string | null } | null };

export type IssueTemporaryPasswordMutationVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type IssueTemporaryPasswordMutation = { __typename?: 'Mutation', issueTemporaryPassword?: { __typename?: 'ResponseTemporaryPasswordType', tempPassword?: string | null } | null };

export type IssueEmailFactorChallengeMutationVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type IssueEmailFactorChallengeMutation = { __typename?: 'Mutation', issueEmailFactorChallenge?: { __typename?: 'IssueEmailFactorChallengeType', emailFactorChallengeEmailSent?: boolean | null } | null };

export type IssueAccountActivationLinkMutationVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type IssueAccountActivationLinkMutation = { __typename?: 'Mutation', issueAccountActivationLink?: { __typename?: 'IssueActivationLinkType', activationUrl?: string | null } | null };

export type IssueAccountActivationEmailMutationVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type IssueAccountActivationEmailMutation = { __typename?: 'Mutation', issueAccountActivationEmail?: { __typename?: 'IssueActivationEmailType', activationEmailSent?: boolean | null } | null };

export type RemoveUserDplTableMutationVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type RemoveUserDplTableMutation = { __typename?: 'Mutation', removeUserDplTable?: { __typename?: 'ResponseDPLDeleteType', message?: string | null } | null };

export type UpdateOktaProfileMutationVariables = Exact<{
  username: Scalars['String']['input'];
  nickName?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOktaProfileMutation = { __typename?: 'Mutation', updateOktaProfile?: { __typename?: 'OktaUserType', email: string, login?: string | null, nickName?: string | null } | null };

export type ChangeUserAttributeMutationVariables = Exact<{
  id: Scalars['String']['input'];
  attribute: Scalars['String']['input'];
  value: Scalars['String']['input'];
}>;


export type ChangeUserAttributeMutation = { __typename?: 'Mutation', changeUserAttribute?: { __typename?: 'OktaUserType', email: string, login?: string | null, email_validation_status?: string | null } | null };

export type ChangeUserStatusMutationVariables = Exact<{
  id: Scalars['String']['input'];
  newStatus: Scalars['String']['input'];
}>;


export type ChangeUserStatusMutation = { __typename?: 'Mutation', changeUserStatus?: { __typename?: 'OktaUserType', email: string, login?: string | null, status?: string | null } | null };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
  ticketNumber: Scalars['String']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser?: boolean | null };

export type GetAdminAppsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminAppsQuery = { __typename?: 'Query', getAdminApps?: { __typename?: 'AdminAppResponse', status?: boolean | null, message?: string | null, data?: { __typename?: 'AppAdminData', appAdminName?: string | null, apps?: Array<{ __typename?: 'AppData', appName?: string | null, appSSOid?: string | null, published?: string | null } | null> | null } | null } | null };

export type GetAppAttributeQueryVariables = Exact<{
  appName: Scalars['String']['input'];
}>;


export type GetAppAttributeQuery = { __typename?: 'Query', getAppAttribute?: { __typename?: 'ApplicationDataResponse', status?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'ApplicationData', attribute_order?: number | null, attribute_is_required?: boolean | null, attribute_key?: string | null, attribute_value?: string | null, attribute_type?: string | null } | null> | null } | null };

export type AddAppAttributeMutationVariables = Exact<{
  data?: InputMaybe<Array<InputMaybe<ApplicationDataInput>> | InputMaybe<ApplicationDataInput>>;
}>;


export type AddAppAttributeMutation = { __typename?: 'Mutation', addAppAttribute?: { __typename?: 'ApplicationDataResponse', status?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'ApplicationData', app_name?: string | null, attribute_order?: number | null, attribute_is_required?: boolean | null, attribute_key?: string | null, attribute_value?: string | null, attribute_type?: string | null } | null> | null } | null };

export type DownloadPiiReportMutationVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type DownloadPiiReportMutation = { __typename?: 'Mutation', downloadPiiReport?: boolean | null };


export const OktaUserDocument = gql`
    query OktaUser($username: String) {
  oktaUserProfile(username: $username) {
    login
    email
    salesforce_id
    id
    dpl_match
    email_double_opt_in
    activated
    created
    email_validation_status
    is_blacklisted
    is_denied_person
    is_onetime_email_bypass_on
    is_partner_inactive
    is_support_portal_admin
    is_whitelisted
    nickName
    partner_oxygen_access
    salesforce_account_id
    salesforce_account_name
    salesforce_lead_source
    status
    streetAddress
    firstName
    lastName
    passwordChanged
    mobilePhone
    primaryPhone
    company
    country
    state
    city
    geo_country
    geo_country_code
    geo_region
    zipCode
    email_double_opt_in
    leadSource
    lastUpdated
    termsAccepted
    termsAcceptedTime
    lastLogin
    statusChanged
    email_double_opt_in_date
    job_function
    job_level
    title
    email_opt_in
    secondEmail
    personal_email
    ip_address
    latitude
    longitude
    manager
    employeeNumber
    countryCode
    ciscoEmail
    salesforce_account_record_type
  }
}
    `;

/**
 * __useOktaUserQuery__
 *
 * To run a query within a React component, call `useOktaUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useOktaUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOktaUserQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useOktaUserQuery(baseOptions?: Apollo.QueryHookOptions<OktaUserQuery, OktaUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OktaUserQuery, OktaUserQueryVariables>(OktaUserDocument, options);
      }
export function useOktaUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OktaUserQuery, OktaUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OktaUserQuery, OktaUserQueryVariables>(OktaUserDocument, options);
        }
// @ts-ignore
export function useOktaUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OktaUserQuery, OktaUserQueryVariables>): Apollo.UseSuspenseQueryResult<OktaUserQuery, OktaUserQueryVariables>;
export function useOktaUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OktaUserQuery, OktaUserQueryVariables>): Apollo.UseSuspenseQueryResult<OktaUserQuery | undefined, OktaUserQueryVariables>;
export function useOktaUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OktaUserQuery, OktaUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OktaUserQuery, OktaUserQueryVariables>(OktaUserDocument, options);
        }
export type OktaUserQueryHookResult = ReturnType<typeof useOktaUserQuery>;
export type OktaUserLazyQueryHookResult = ReturnType<typeof useOktaUserLazyQuery>;
export type OktaUserSuspenseQueryHookResult = ReturnType<typeof useOktaUserSuspenseQuery>;
export type OktaUserQueryResult = Apollo.QueryResult<OktaUserQuery, OktaUserQueryVariables>;
export const CheckDplTableDocument = gql`
    query CheckDPLTable($username: String!) {
  checkDplTableUser(username: $username) {
    dpl_match
  }
}
    `;

/**
 * __useCheckDplTableQuery__
 *
 * To run a query within a React component, call `useCheckDplTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckDplTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckDplTableQuery({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useCheckDplTableQuery(baseOptions: Apollo.QueryHookOptions<CheckDplTableQuery, CheckDplTableQueryVariables> & ({ variables: CheckDplTableQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckDplTableQuery, CheckDplTableQueryVariables>(CheckDplTableDocument, options);
      }
export function useCheckDplTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckDplTableQuery, CheckDplTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckDplTableQuery, CheckDplTableQueryVariables>(CheckDplTableDocument, options);
        }
// @ts-ignore
export function useCheckDplTableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckDplTableQuery, CheckDplTableQueryVariables>): Apollo.UseSuspenseQueryResult<CheckDplTableQuery, CheckDplTableQueryVariables>;
export function useCheckDplTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckDplTableQuery, CheckDplTableQueryVariables>): Apollo.UseSuspenseQueryResult<CheckDplTableQuery | undefined, CheckDplTableQueryVariables>;
export function useCheckDplTableSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CheckDplTableQuery, CheckDplTableQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckDplTableQuery, CheckDplTableQueryVariables>(CheckDplTableDocument, options);
        }
export type CheckDplTableQueryHookResult = ReturnType<typeof useCheckDplTableQuery>;
export type CheckDplTableLazyQueryHookResult = ReturnType<typeof useCheckDplTableLazyQuery>;
export type CheckDplTableSuspenseQueryHookResult = ReturnType<typeof useCheckDplTableSuspenseQuery>;
export type CheckDplTableQueryResult = Apollo.QueryResult<CheckDplTableQuery, CheckDplTableQueryVariables>;
export const GetSystemLogsDocument = gql`
    query GetSystemLogs($email: String!, $startTime: String!, $endTime: String!) {
  getSystemLogs(email: $email, startTime: $startTime, endTime: $endTime) {
    actor
    time
    eventInfo {
      message
      outcome
      type
    }
    target {
      alternateId
      detailEntry
      displayName
      type
    }
  }
}
    `;

/**
 * __useGetSystemLogsQuery__
 *
 * To run a query within a React component, call `useGetSystemLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSystemLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSystemLogsQuery({
 *   variables: {
 *      email: // value for 'email'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useGetSystemLogsQuery(baseOptions: Apollo.QueryHookOptions<GetSystemLogsQuery, GetSystemLogsQueryVariables> & ({ variables: GetSystemLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSystemLogsQuery, GetSystemLogsQueryVariables>(GetSystemLogsDocument, options);
      }
export function useGetSystemLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSystemLogsQuery, GetSystemLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSystemLogsQuery, GetSystemLogsQueryVariables>(GetSystemLogsDocument, options);
        }
// @ts-ignore
export function useGetSystemLogsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSystemLogsQuery, GetSystemLogsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSystemLogsQuery, GetSystemLogsQueryVariables>;
export function useGetSystemLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSystemLogsQuery, GetSystemLogsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSystemLogsQuery | undefined, GetSystemLogsQueryVariables>;
export function useGetSystemLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSystemLogsQuery, GetSystemLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSystemLogsQuery, GetSystemLogsQueryVariables>(GetSystemLogsDocument, options);
        }
export type GetSystemLogsQueryHookResult = ReturnType<typeof useGetSystemLogsQuery>;
export type GetSystemLogsLazyQueryHookResult = ReturnType<typeof useGetSystemLogsLazyQuery>;
export type GetSystemLogsSuspenseQueryHookResult = ReturnType<typeof useGetSystemLogsSuspenseQuery>;
export type GetSystemLogsQueryResult = Apollo.QueryResult<GetSystemLogsQuery, GetSystemLogsQueryVariables>;
export const DplScreenDocument = gql`
    query DplScreen($email: String!) {
  dplScreen(email: $email) {
    firstName
    lastName
    email
    company
    country
    created
  }
}
    `;

/**
 * __useDplScreenQuery__
 *
 * To run a query within a React component, call `useDplScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useDplScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDplScreenQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useDplScreenQuery(baseOptions: Apollo.QueryHookOptions<DplScreenQuery, DplScreenQueryVariables> & ({ variables: DplScreenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DplScreenQuery, DplScreenQueryVariables>(DplScreenDocument, options);
      }
export function useDplScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DplScreenQuery, DplScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DplScreenQuery, DplScreenQueryVariables>(DplScreenDocument, options);
        }
// @ts-ignore
export function useDplScreenSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DplScreenQuery, DplScreenQueryVariables>): Apollo.UseSuspenseQueryResult<DplScreenQuery, DplScreenQueryVariables>;
export function useDplScreenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DplScreenQuery, DplScreenQueryVariables>): Apollo.UseSuspenseQueryResult<DplScreenQuery | undefined, DplScreenQueryVariables>;
export function useDplScreenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DplScreenQuery, DplScreenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DplScreenQuery, DplScreenQueryVariables>(DplScreenDocument, options);
        }
export type DplScreenQueryHookResult = ReturnType<typeof useDplScreenQuery>;
export type DplScreenLazyQueryHookResult = ReturnType<typeof useDplScreenLazyQuery>;
export type DplScreenSuspenseQueryHookResult = ReturnType<typeof useDplScreenSuspenseQuery>;
export type DplScreenQueryResult = Apollo.QueryResult<DplScreenQuery, DplScreenQueryVariables>;
export const IssuePasswordResetEmailDocument = gql`
    mutation IssuePasswordResetEmail($username: String!) {
  issuePasswordResetEmail(username: $username) {
    emailSent
    userType
  }
}
    `;
export type IssuePasswordResetEmailMutationFn = Apollo.MutationFunction<IssuePasswordResetEmailMutation, IssuePasswordResetEmailMutationVariables>;

/**
 * __useIssuePasswordResetEmailMutation__
 *
 * To run a mutation, you first call `useIssuePasswordResetEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssuePasswordResetEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issuePasswordResetEmailMutation, { data, loading, error }] = useIssuePasswordResetEmailMutation({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useIssuePasswordResetEmailMutation(baseOptions?: Apollo.MutationHookOptions<IssuePasswordResetEmailMutation, IssuePasswordResetEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssuePasswordResetEmailMutation, IssuePasswordResetEmailMutationVariables>(IssuePasswordResetEmailDocument, options);
      }
export type IssuePasswordResetEmailMutationHookResult = ReturnType<typeof useIssuePasswordResetEmailMutation>;
export type IssuePasswordResetEmailMutationResult = Apollo.MutationResult<IssuePasswordResetEmailMutation>;
export type IssuePasswordResetEmailMutationOptions = Apollo.BaseMutationOptions<IssuePasswordResetEmailMutation, IssuePasswordResetEmailMutationVariables>;
export const IssueTemporaryPasswordDocument = gql`
    mutation IssueTemporaryPassword($username: String!) {
  issueTemporaryPassword(username: $username) {
    tempPassword
  }
}
    `;
export type IssueTemporaryPasswordMutationFn = Apollo.MutationFunction<IssueTemporaryPasswordMutation, IssueTemporaryPasswordMutationVariables>;

/**
 * __useIssueTemporaryPasswordMutation__
 *
 * To run a mutation, you first call `useIssueTemporaryPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueTemporaryPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueTemporaryPasswordMutation, { data, loading, error }] = useIssueTemporaryPasswordMutation({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useIssueTemporaryPasswordMutation(baseOptions?: Apollo.MutationHookOptions<IssueTemporaryPasswordMutation, IssueTemporaryPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssueTemporaryPasswordMutation, IssueTemporaryPasswordMutationVariables>(IssueTemporaryPasswordDocument, options);
      }
export type IssueTemporaryPasswordMutationHookResult = ReturnType<typeof useIssueTemporaryPasswordMutation>;
export type IssueTemporaryPasswordMutationResult = Apollo.MutationResult<IssueTemporaryPasswordMutation>;
export type IssueTemporaryPasswordMutationOptions = Apollo.BaseMutationOptions<IssueTemporaryPasswordMutation, IssueTemporaryPasswordMutationVariables>;
export const IssueEmailFactorChallengeDocument = gql`
    mutation IssueEmailFactorChallenge($username: String!) {
  issueEmailFactorChallenge(username: $username) {
    emailFactorChallengeEmailSent
  }
}
    `;
export type IssueEmailFactorChallengeMutationFn = Apollo.MutationFunction<IssueEmailFactorChallengeMutation, IssueEmailFactorChallengeMutationVariables>;

/**
 * __useIssueEmailFactorChallengeMutation__
 *
 * To run a mutation, you first call `useIssueEmailFactorChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueEmailFactorChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueEmailFactorChallengeMutation, { data, loading, error }] = useIssueEmailFactorChallengeMutation({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useIssueEmailFactorChallengeMutation(baseOptions?: Apollo.MutationHookOptions<IssueEmailFactorChallengeMutation, IssueEmailFactorChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssueEmailFactorChallengeMutation, IssueEmailFactorChallengeMutationVariables>(IssueEmailFactorChallengeDocument, options);
      }
export type IssueEmailFactorChallengeMutationHookResult = ReturnType<typeof useIssueEmailFactorChallengeMutation>;
export type IssueEmailFactorChallengeMutationResult = Apollo.MutationResult<IssueEmailFactorChallengeMutation>;
export type IssueEmailFactorChallengeMutationOptions = Apollo.BaseMutationOptions<IssueEmailFactorChallengeMutation, IssueEmailFactorChallengeMutationVariables>;
export const IssueAccountActivationLinkDocument = gql`
    mutation IssueAccountActivationLink($username: String!) {
  issueAccountActivationLink(username: $username) {
    activationUrl
  }
}
    `;
export type IssueAccountActivationLinkMutationFn = Apollo.MutationFunction<IssueAccountActivationLinkMutation, IssueAccountActivationLinkMutationVariables>;

/**
 * __useIssueAccountActivationLinkMutation__
 *
 * To run a mutation, you first call `useIssueAccountActivationLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueAccountActivationLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueAccountActivationLinkMutation, { data, loading, error }] = useIssueAccountActivationLinkMutation({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useIssueAccountActivationLinkMutation(baseOptions?: Apollo.MutationHookOptions<IssueAccountActivationLinkMutation, IssueAccountActivationLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssueAccountActivationLinkMutation, IssueAccountActivationLinkMutationVariables>(IssueAccountActivationLinkDocument, options);
      }
export type IssueAccountActivationLinkMutationHookResult = ReturnType<typeof useIssueAccountActivationLinkMutation>;
export type IssueAccountActivationLinkMutationResult = Apollo.MutationResult<IssueAccountActivationLinkMutation>;
export type IssueAccountActivationLinkMutationOptions = Apollo.BaseMutationOptions<IssueAccountActivationLinkMutation, IssueAccountActivationLinkMutationVariables>;
export const IssueAccountActivationEmailDocument = gql`
    mutation IssueAccountActivationEmail($username: String!) {
  issueAccountActivationEmail(username: $username) {
    activationEmailSent
  }
}
    `;
export type IssueAccountActivationEmailMutationFn = Apollo.MutationFunction<IssueAccountActivationEmailMutation, IssueAccountActivationEmailMutationVariables>;

/**
 * __useIssueAccountActivationEmailMutation__
 *
 * To run a mutation, you first call `useIssueAccountActivationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueAccountActivationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueAccountActivationEmailMutation, { data, loading, error }] = useIssueAccountActivationEmailMutation({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useIssueAccountActivationEmailMutation(baseOptions?: Apollo.MutationHookOptions<IssueAccountActivationEmailMutation, IssueAccountActivationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IssueAccountActivationEmailMutation, IssueAccountActivationEmailMutationVariables>(IssueAccountActivationEmailDocument, options);
      }
export type IssueAccountActivationEmailMutationHookResult = ReturnType<typeof useIssueAccountActivationEmailMutation>;
export type IssueAccountActivationEmailMutationResult = Apollo.MutationResult<IssueAccountActivationEmailMutation>;
export type IssueAccountActivationEmailMutationOptions = Apollo.BaseMutationOptions<IssueAccountActivationEmailMutation, IssueAccountActivationEmailMutationVariables>;
export const RemoveUserDplTableDocument = gql`
    mutation RemoveUserDPLTable($username: String!) {
  removeUserDplTable(username: $username) {
    message
  }
}
    `;
export type RemoveUserDplTableMutationFn = Apollo.MutationFunction<RemoveUserDplTableMutation, RemoveUserDplTableMutationVariables>;

/**
 * __useRemoveUserDplTableMutation__
 *
 * To run a mutation, you first call `useRemoveUserDplTableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserDplTableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserDplTableMutation, { data, loading, error }] = useRemoveUserDplTableMutation({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useRemoveUserDplTableMutation(baseOptions?: Apollo.MutationHookOptions<RemoveUserDplTableMutation, RemoveUserDplTableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveUserDplTableMutation, RemoveUserDplTableMutationVariables>(RemoveUserDplTableDocument, options);
      }
export type RemoveUserDplTableMutationHookResult = ReturnType<typeof useRemoveUserDplTableMutation>;
export type RemoveUserDplTableMutationResult = Apollo.MutationResult<RemoveUserDplTableMutation>;
export type RemoveUserDplTableMutationOptions = Apollo.BaseMutationOptions<RemoveUserDplTableMutation, RemoveUserDplTableMutationVariables>;
export const UpdateOktaProfileDocument = gql`
    mutation UpdateOktaProfile($username: String!, $nickName: String) {
  updateOktaProfile(username: $username, nickName: $nickName) {
    email
    login
    nickName
  }
}
    `;
export type UpdateOktaProfileMutationFn = Apollo.MutationFunction<UpdateOktaProfileMutation, UpdateOktaProfileMutationVariables>;

/**
 * __useUpdateOktaProfileMutation__
 *
 * To run a mutation, you first call `useUpdateOktaProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOktaProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOktaProfileMutation, { data, loading, error }] = useUpdateOktaProfileMutation({
 *   variables: {
 *      username: // value for 'username'
 *      nickName: // value for 'nickName'
 *   },
 * });
 */
export function useUpdateOktaProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOktaProfileMutation, UpdateOktaProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOktaProfileMutation, UpdateOktaProfileMutationVariables>(UpdateOktaProfileDocument, options);
      }
export type UpdateOktaProfileMutationHookResult = ReturnType<typeof useUpdateOktaProfileMutation>;
export type UpdateOktaProfileMutationResult = Apollo.MutationResult<UpdateOktaProfileMutation>;
export type UpdateOktaProfileMutationOptions = Apollo.BaseMutationOptions<UpdateOktaProfileMutation, UpdateOktaProfileMutationVariables>;
export const ChangeUserAttributeDocument = gql`
    mutation ChangeUserAttribute($id: String!, $attribute: String!, $value: String!) {
  changeUserAttribute(id: $id, attribute: $attribute, value: $value) {
    email
    login
    email_validation_status
  }
}
    `;
export type ChangeUserAttributeMutationFn = Apollo.MutationFunction<ChangeUserAttributeMutation, ChangeUserAttributeMutationVariables>;

/**
 * __useChangeUserAttributeMutation__
 *
 * To run a mutation, you first call `useChangeUserAttributeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUserAttributeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUserAttributeMutation, { data, loading, error }] = useChangeUserAttributeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      attribute: // value for 'attribute'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useChangeUserAttributeMutation(baseOptions?: Apollo.MutationHookOptions<ChangeUserAttributeMutation, ChangeUserAttributeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeUserAttributeMutation, ChangeUserAttributeMutationVariables>(ChangeUserAttributeDocument, options);
      }
export type ChangeUserAttributeMutationHookResult = ReturnType<typeof useChangeUserAttributeMutation>;
export type ChangeUserAttributeMutationResult = Apollo.MutationResult<ChangeUserAttributeMutation>;
export type ChangeUserAttributeMutationOptions = Apollo.BaseMutationOptions<ChangeUserAttributeMutation, ChangeUserAttributeMutationVariables>;
export const ChangeUserStatusDocument = gql`
    mutation ChangeUserStatus($id: String!, $newStatus: String!) {
  changeUserStatus(id: $id, newStatus: $newStatus) {
    email
    login
    status
  }
}
    `;
export type ChangeUserStatusMutationFn = Apollo.MutationFunction<ChangeUserStatusMutation, ChangeUserStatusMutationVariables>;

/**
 * __useChangeUserStatusMutation__
 *
 * To run a mutation, you first call `useChangeUserStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUserStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUserStatusMutation, { data, loading, error }] = useChangeUserStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      newStatus: // value for 'newStatus'
 *   },
 * });
 */
export function useChangeUserStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeUserStatusMutation, ChangeUserStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeUserStatusMutation, ChangeUserStatusMutationVariables>(ChangeUserStatusDocument, options);
      }
export type ChangeUserStatusMutationHookResult = ReturnType<typeof useChangeUserStatusMutation>;
export type ChangeUserStatusMutationResult = Apollo.MutationResult<ChangeUserStatusMutation>;
export type ChangeUserStatusMutationOptions = Apollo.BaseMutationOptions<ChangeUserStatusMutation, ChangeUserStatusMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($id: String!, $ticketNumber: String!) {
  deleteUser(id: $id, ticketNumber: $ticketNumber)
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      ticketNumber: // value for 'ticketNumber'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const GetAdminAppsDocument = gql`
    query GetAdminApps {
  getAdminApps {
    status
    message
    data {
      appAdminName
      apps {
        appName
        appSSOid
        published
      }
    }
  }
}
    `;

/**
 * __useGetAdminAppsQuery__
 *
 * To run a query within a React component, call `useGetAdminAppsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminAppsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminAppsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminAppsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminAppsQuery, GetAdminAppsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminAppsQuery, GetAdminAppsQueryVariables>(GetAdminAppsDocument, options);
      }
export function useGetAdminAppsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminAppsQuery, GetAdminAppsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminAppsQuery, GetAdminAppsQueryVariables>(GetAdminAppsDocument, options);
        }
// @ts-ignore
export function useGetAdminAppsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminAppsQuery, GetAdminAppsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdminAppsQuery, GetAdminAppsQueryVariables>;
export function useGetAdminAppsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminAppsQuery, GetAdminAppsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdminAppsQuery | undefined, GetAdminAppsQueryVariables>;
export function useGetAdminAppsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminAppsQuery, GetAdminAppsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminAppsQuery, GetAdminAppsQueryVariables>(GetAdminAppsDocument, options);
        }
export type GetAdminAppsQueryHookResult = ReturnType<typeof useGetAdminAppsQuery>;
export type GetAdminAppsLazyQueryHookResult = ReturnType<typeof useGetAdminAppsLazyQuery>;
export type GetAdminAppsSuspenseQueryHookResult = ReturnType<typeof useGetAdminAppsSuspenseQuery>;
export type GetAdminAppsQueryResult = Apollo.QueryResult<GetAdminAppsQuery, GetAdminAppsQueryVariables>;
export const GetAppAttributeDocument = gql`
    query GetAppAttribute($appName: String!) {
  getAppAttribute(appName: $appName) {
    status
    message
    data {
      attribute_order
      attribute_is_required
      attribute_key
      attribute_value
      attribute_type
    }
  }
}
    `;

/**
 * __useGetAppAttributeQuery__
 *
 * To run a query within a React component, call `useGetAppAttributeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppAttributeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppAttributeQuery({
 *   variables: {
 *      appName: // value for 'appName'
 *   },
 * });
 */
export function useGetAppAttributeQuery(baseOptions: Apollo.QueryHookOptions<GetAppAttributeQuery, GetAppAttributeQueryVariables> & ({ variables: GetAppAttributeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppAttributeQuery, GetAppAttributeQueryVariables>(GetAppAttributeDocument, options);
      }
export function useGetAppAttributeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppAttributeQuery, GetAppAttributeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppAttributeQuery, GetAppAttributeQueryVariables>(GetAppAttributeDocument, options);
        }
// @ts-ignore
export function useGetAppAttributeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAppAttributeQuery, GetAppAttributeQueryVariables>): Apollo.UseSuspenseQueryResult<GetAppAttributeQuery, GetAppAttributeQueryVariables>;
export function useGetAppAttributeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppAttributeQuery, GetAppAttributeQueryVariables>): Apollo.UseSuspenseQueryResult<GetAppAttributeQuery | undefined, GetAppAttributeQueryVariables>;
export function useGetAppAttributeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAppAttributeQuery, GetAppAttributeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAppAttributeQuery, GetAppAttributeQueryVariables>(GetAppAttributeDocument, options);
        }
export type GetAppAttributeQueryHookResult = ReturnType<typeof useGetAppAttributeQuery>;
export type GetAppAttributeLazyQueryHookResult = ReturnType<typeof useGetAppAttributeLazyQuery>;
export type GetAppAttributeSuspenseQueryHookResult = ReturnType<typeof useGetAppAttributeSuspenseQuery>;
export type GetAppAttributeQueryResult = Apollo.QueryResult<GetAppAttributeQuery, GetAppAttributeQueryVariables>;
export const AddAppAttributeDocument = gql`
    mutation AddAppAttribute($data: [ApplicationDataInput]) {
  addAppAttribute(data: $data) {
    status
    message
    data {
      app_name
      attribute_order
      attribute_is_required
      attribute_key
      attribute_value
      attribute_type
    }
  }
}
    `;
export type AddAppAttributeMutationFn = Apollo.MutationFunction<AddAppAttributeMutation, AddAppAttributeMutationVariables>;

/**
 * __useAddAppAttributeMutation__
 *
 * To run a mutation, you first call `useAddAppAttributeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAppAttributeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAppAttributeMutation, { data, loading, error }] = useAddAppAttributeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAddAppAttributeMutation(baseOptions?: Apollo.MutationHookOptions<AddAppAttributeMutation, AddAppAttributeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAppAttributeMutation, AddAppAttributeMutationVariables>(AddAppAttributeDocument, options);
      }
export type AddAppAttributeMutationHookResult = ReturnType<typeof useAddAppAttributeMutation>;
export type AddAppAttributeMutationResult = Apollo.MutationResult<AddAppAttributeMutation>;
export type AddAppAttributeMutationOptions = Apollo.BaseMutationOptions<AddAppAttributeMutation, AddAppAttributeMutationVariables>;
export const DownloadPiiReportDocument = gql`
    mutation DownloadPiiReport($username: String!) {
  downloadPiiReport(username: $username)
}
    `;
export type DownloadPiiReportMutationFn = Apollo.MutationFunction<DownloadPiiReportMutation, DownloadPiiReportMutationVariables>;

/**
 * __useDownloadPiiReportMutation__
 *
 * To run a mutation, you first call `useDownloadPiiReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadPiiReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadPiiReportMutation, { data, loading, error }] = useDownloadPiiReportMutation({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useDownloadPiiReportMutation(baseOptions?: Apollo.MutationHookOptions<DownloadPiiReportMutation, DownloadPiiReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DownloadPiiReportMutation, DownloadPiiReportMutationVariables>(DownloadPiiReportDocument, options);
      }
export type DownloadPiiReportMutationHookResult = ReturnType<typeof useDownloadPiiReportMutation>;
export type DownloadPiiReportMutationResult = Apollo.MutationResult<DownloadPiiReportMutation>;
export type DownloadPiiReportMutationOptions = Apollo.BaseMutationOptions<DownloadPiiReportMutation, DownloadPiiReportMutationVariables>;